export const FOLLOW_RETRY_CAP_SECONDS = 22.5;
export const FOLLOW_OUTAGE_FEEDBACK_MS = 5 * 60 * 1_000;
// The platform's own transient class, kept identical: see TRANSIENT_STATUS in
// packages/tasks/src/lib/failure/classify/classify-harness-failure-constants.ts.
export const RETRYABLE_FOLLOW_STATUS = new Set([
  408, 425, 429, 500, 502, 503, 504,
]);
